<template>
  <footer :class="['footer', { 'footer--fixed': fixed, 'footer--negative': negative }]">
    <sui-grid :columns="2" :width="1">
      <sui-grid-row>
        <sui-grid-column :computer="11" :mobile="11">
          <img class="footer__logo" alt="We are David" title="David Logo" :src="getLogo" />
          <span class="footer__animated-names">
            WE ARE <br />
            <transition
              enter-active-class="animated fadeInUp"
              leave-active-class="animated fadeOutUp"
              mode="out-in"
            >
              <span v-show="visibleNames" class="footer__animated-names--animation">
                {{ currentName }}
              </span>
            </transition>
          </span>
        </sui-grid-column>
        <sui-grid-column :computer="5" :mobile="5" class="footer__menu">
          <div class="footer__menu__content">
            <div class="footer__menu__followus">
              {{ $t("footer.followus") }} <br />
              Instagram
            </div>
            <div class="footer__menu__list">
              <ul>
                <a href="https://www.instagram.com/wearedavid.sp/" target="_blank">
                  <li>São Paulo</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.mia/" target="_blank">
                  <li>Miami</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.ba/" target="_blank">
                  <li>Buenos Aires</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.bog/" target="_blank">
                  <li>Bogota</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.mad/" target="_blank">
                  <li>Madrid</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.ny/" target="_blank">
                  <li>New York</li>
                </a>
                <a href="https://www.instagram.com/wearedavid.ldn/" target="_blank">
                  <li>London</li>
                </a>
              </ul>
            </div>
          </div>
          <div class="footer__menu__disclaimer">
            <span v-if="$i18n.locale === 'pt'">
              <a href="pdf/relatorio-transparencia-salarial.pdf" target="_blank">
                Relatório de Transparência e Igualdade Salarial<br />
                de Mulheres e Homens da DAVID São Paulo
              </a>
            </span>
            <br /><br />
            © DAVID 2022 · {{ $t("footer.copyright") }}
          </div>
        </sui-grid-column>

        <div class="footer__disclaimer-mobile">
          <span v-if="$i18n.locale === 'pt'">
            <a href="/pdf/relatorio-transparencia-salarial.pdf" target="_blank">
              Relatório de Transparência e Igualdade Salarial<br />
              de Mulheres e Homens da DAVID São Paulo
            </a>
          </span>
          <br /><br />
          © DAVID 2022 · {{ $t("footer.copyright") }}
        </div>
      </sui-grid-row>
    </sui-grid>
  </footer>
</template>

<script>
import Logo from "@/assets/logo-david-white-sr.png";
import LogoBlack from "@/assets/logo-david-short-black.png";

export default {
  name: "main-footer",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    negative: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleNames: true,
      logo: null,
      interval: null,
      currentName: "David",
      animated: false,
      names: ["David", "Musa", "Pancho", "Robert", "Marcus", "Anna"],
    };
  },

  mounted() {
    this.$hub.$on("animateFooter", this.startNamesAnimation);
    this.getNames();
  },

  computed: {
    getLogo() {
      return this.$route.name === "works" || this.$route.name === "AboutUs" ? LogoBlack : Logo;
    },
  },

  methods: {
    getNames() {
      this.$namesFooter.getData().then((res) => {
        this.names = res.data;
        this.currentName = "David";
        this.names.unshift("David");
      });
    },

    startNamesAnimation() {
      if (!this.animated) {
        this.timeInterval = setInterval(this.animateName, 2500);
        this.animated = true;
      }
    },

    animateName() {
      let nextNameIndex = this.names.findIndex((name) => name === this.currentName) + 1;

      if (nextNameIndex > this.names.length - 1) {
        nextNameIndex = 0;
      }

      setTimeout(() => {
        this.currentName = this.names[nextNameIndex];
      }, 800);
    },
  },
};
</script>

<style lang="scss">
@import "./styles/footer";
</style>
